import { createStyles } from '@mantine/core'

export default createStyles((_theme) => {
  return {
    root: {},
  }
})
